export function getCrateDownloadPresentation(versions) {
  let showSubscribe = false;
  const actions = [];

  for (const item of versions) {
    if (!item.version || !item.published) continue;

    const exhausted = Boolean(
      item.entitlement &&
      typeof item.entitlement.remainingDownloads === 'number' &&
      item.entitlement.remainingDownloads <= 0
    );

    // Ownership is authoritative for the exact TrackVersion. An already-owned
    // version with remaining downloads stays directly downloadable even while
    // the credit request is loading or unavailable because downloads do not
    // spend credits.
    if (item.entitlement && !exhausted) {
      actions.push({ type: 'download', key: item.key });
      continue;
    }

    // Credit state is version-specific presentation state. It must not hide a
    // sibling version's action when that sibling is ready to unlock or renew.
    if (item.creditStatePending) continue;
    if (item.needsSubscribe || item.creditStateError) {
      showSubscribe = true;
      continue;
    }

    actions.push({ type: 'download', key: item.key });
  }

  if (showSubscribe) actions.push({ type: 'subscribe' });
  return { actions, showSubscribe };
}
